export enum TOGGLE_VARIANTS {
	TRUE = 'ТАК',
	FALSE = 'НІ',
}
